import * as React from 'react'

import { Link } from '@leshen/ui'
import { Link as GatsbyLink } from 'gatsby'

import { useMapi } from '../context/MapiProvider'
import { useUser } from '../context/UserProvider'

const relativeLinkRegex = /^\/(?!\/)/

const LeshenLink = ({ children, to = null, ...props }) => {
  const { sessionPromoCode, requestId, rotatedNumber } = useMapi()
  const { userLocation } = useUser() || {}
  let linkTo = to

  if (typeof linkTo === 'string') {
    linkTo = to
      ?.replace('{PROMO_CODE}', sessionPromoCode)
      ?.replace('{REQUEST_ID}', requestId)
      ?.replace('{PHONE}', rotatedNumber)
      ?.replace('{USER_ZIP_CODE}', userLocation?.zipCode)
      ?.replace(
        '{USER_CITY}',
        userLocation?.city?.toLowerCase()?.replace(' ', '-')
      )
      ?.replace(
        '{USER_STATE}',
        userLocation?.state?.fullName?.toLowerCase()?.replace(' ', '-')
      )
  }

  const replaceTextContent = (text) => text?.replace('{PHONE}', rotatedNumber)

  let textContent

  if (typeof children === 'string') {
    textContent = replaceTextContent(children)
  } else if (Array.isArray(children[0]) && typeof children[0][1] === 'string') {
    textContent = replaceTextContent(children[0][1])
  } else {
    textContent = children
  }

  const isRelativeLink = relativeLinkRegex.test(to)

  if (!isRelativeLink) {
    return (
      <Link to={linkTo} {...props}>
        {textContent}
      </Link>
    )
  }

  return (
    <GatsbyLink to={linkTo} {...props}>
      {textContent}
    </GatsbyLink>
  )
}

export default LeshenLink
